/**
 * 역할별 메뉴 설정
 */

import {
  DashboardOutlined,
  TeamOutlined,
  UserOutlined,
  BookOutlined,
  CheckOutlined,
  BarChartOutlined,
  HomeOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { MenuItem } from './types';
import { UserRole } from '../../types/user';

/**
 * 전체 메뉴 아이템 목록
 * 역할별로 필터링되어 사용됨
 */
export const ALL_MENU_ITEMS: MenuItem[] = [
  {
    key: '/system',
    label: '시스템 대시보드',
    icon: <HomeOutlined />,
    roles: ['admin'],
  },
  {
    key: '/dashboard',
    label: '대시보드',
    icon: <DashboardOutlined />,
    roles: ['admin', 'group_admin', 'instructor'],
  },
  {
    key: '/groups',
    label: '그룹 관리',
    icon: <TeamOutlined />,
    roles: ['admin', 'group_admin'],
  },
  {
    key: '/users',
    label: '사용자 관리',
    icon: <UserOutlined />,
    roles: ['admin', 'group_admin'],
  },
  {
    key: '/workbooks',
    label: '문제집 관리',
    icon: <BookOutlined />,
    roles: ['admin', 'group_admin', 'instructor'],
  },
  {
    key: '/workbooks/upload',
    label: 'Excel 업로드',
    icon: <UploadOutlined />,
    roles: ['admin'],  // 시스템 관리자만 접근 가능
  },
  {
    key: '/students',
    label: '담당 학생',
    icon: <UserOutlined />,
    roles: ['instructor'],
  },
  {
    key: '/grading',
    label: '채점 관리',
    icon: <CheckOutlined />,
    roles: ['admin', 'group_admin', 'instructor'],
  },
  {
    key: '/stats',
    label: '통계 및 분석',
    icon: <BarChartOutlined />,
    roles: ['admin', 'group_admin', 'instructor'],
  },
];

/**
 * 역할에 따라 접근 가능한 메뉴 아이템 필터링
 * @param userRole - 사용자 역할
 * @returns 필터링된 메뉴 아이템 배열
 */
export const getMenuItemsByRole = (userRole: UserRole): MenuItem[] => {
  return ALL_MENU_ITEMS.filter((item) => item.roles.includes(userRole));
};

/**
 * 역할별 역할명 라벨 반환
 * @param role - 사용자 역할
 * @returns 한글 역할명
 */
export const getRoleLabel = (role: UserRole): string => {
  const roleLabels: Record<UserRole, string> = {
    admin: '시스템 관리자',
    group_admin: '그룹 관리자',
    instructor: '강사',
    student: '학생',
  };
  return roleLabels[role] || role;
};

/**
 * 역할별 배지 색상 반환
 * @param role - 사용자 역할
 * @returns Ant Design Tag 색상
 */
export const getRoleColor = (role: UserRole): string => {
  const roleColors: Record<UserRole, string> = {
    admin: 'purple',
    group_admin: 'blue',
    instructor: 'green',
    student: 'orange',
  };
  return roleColors[role] || 'default';
};
